import { useEffect, useState } from 'react';
import '../index.css';
import { NavLink } from 'react-router-dom';

function DisplayRoomInfo({ phoneNumberData, roomNumber }) {
    // Find data for the specific room number
    const filteredData = phoneNumberData.find(item => item.room_number === roomNumber);

    return (
        <div className="flex flex-col">
            <div className={`map-box-room ${filteredData && !filteredData.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                {roomNumber}
            </div>
            {filteredData && filteredData.tenant_phone_number ? (
                <a className="map-box-phone" href={`tel:${filteredData.tenant_phone_number}`}>
                    {filteredData.tenant_phone_number}
                </a>
            ) : (
                <div className="map-box-phone" >No data</div>
            )}
        </div>
    );
}

export default function BuildingMap() {
    const [phoneNumberData, setPhoneNumberData] = useState([]);
    let startBuildingN;
    let endBuildingN;
    const [buildingN, setBuildingN] = useState([]);

    const [buildingD1, setBuildingD1] = useState([]);
    const [buildingD2, setBuildingD2] = useState([]);
    
    const [buildingA1, setBuildingA1] = useState([]);
    const [buildingA2, setBuildingA2] = useState([]);
    
    const [buildingB1, setBuildingB1] = useState([]);
    const [buildingB2, setBuildingB2] = useState([]);
    
    const [buildingC, setBuildingC] = useState([]);
    
    const [buildingK, setBuildingK] = useState([]);

    const [buildingR, setBuildingR] = useState([]);
    
    const [buildingH2024, setBuildingH2024] = useState([]);
    const [buildingH1519, setBuildingH1519] = useState([]);
    const [buildingH0107, setBuildingH0107] = useState([]);
    const [buildingH0814, setBuildingH0814] = useState([]);

    const [buildingH4448, setBuildingH4448] = useState([]);
    const [buildingH3943, setBuildingH3943] = useState([]);
    const [buildingH2531, setBuildingH2531] = useState([]);
    const [buildingH3238, setBuildingH3238] = useState([]);
    
    const [buildingH6872, setBuildingH6872] = useState([]);
    const [buildingH6367, setBuildingH6367] = useState([]);
    const [buildingH4955, setBuildingH4955] = useState([]);
    const [buildingH5662, setBuildingH5662] = useState([]);
    // =========================>> Fetch API
    const getPhoneNumber = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/room/room-phone-number`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.message || 'Failed to fetch phone number.');
            }

            const data = await response.json();
            setPhoneNumberData(data);
            startBuildingN = data.findIndex(item => item.room_number === 'N03');
            endBuildingN = data.findIndex(item => item.room_number === 'N12');
            setBuildingN(data.slice(startBuildingN, endBuildingN + 1));
            setBuildingD1(data.slice(data.findIndex(item => item.room_number === 'D11'), data.findIndex(item => item.room_number === 'D18') + 1).reverse());
            setBuildingD2(data.slice(data.findIndex(item => item.room_number === 'D01'), data.findIndex(item => item.room_number === 'D08') + 1));
            setBuildingA1(data.slice(data.findIndex(item => item.room_number === 'A09'), data.findIndex(item => item.room_number === 'A16') + 1).reverse());
            setBuildingA2(data.slice(data.findIndex(item => item.room_number === 'A01'), data.findIndex(item => item.room_number === 'A08') + 1));
            setBuildingB1(data.slice(data.findIndex(item => item.room_number === 'B01'), data.findIndex(item => item.room_number === 'B07') + 1));
            setBuildingB2(data.slice(data.findIndex(item => item.room_number === 'B08'), data.findIndex(item => item.room_number === 'B14') + 1).reverse());
            setBuildingC(['C06', 'C05', 'C04', 'C03', 'C02', 'C01'].map(roomNumber => data.find(item => item.room_number === roomNumber)).filter(Boolean));
            setBuildingK(data.slice(data.findIndex(item => item.room_number === 'K01'), data.findIndex(item => item.room_number === 'K12') + 1));
            setBuildingR(data.slice(data.findIndex(item => item.room_number === 'R01'), data.findIndex(item => item.room_number === 'R14') + 1));
            setBuildingH2024(data.slice(data.findIndex(item => item.room_number === 'H20'), data.findIndex(item => item.room_number === 'H24') + 1));
            setBuildingH1519(data.slice(data.findIndex(item => item.room_number === 'H15'), data.findIndex(item => item.room_number === 'H19') + 1).reverse());
            setBuildingH0107(data.slice(data.findIndex(item => item.room_number === 'H01'), data.findIndex(item => item.room_number === 'H07') + 1));
            setBuildingH0814(data.slice(data.findIndex(item => item.room_number === 'H08'), data.findIndex(item => item.room_number === 'H14') + 1).reverse());
            setBuildingH4448(data.slice(data.findIndex(item => item.room_number === 'H44'), data.findIndex(item => item.room_number === 'H48') + 1));
            setBuildingH3943(data.slice(data.findIndex(item => item.room_number === 'H39'), data.findIndex(item => item.room_number === 'H43') + 1).reverse());
            setBuildingH2531(data.slice(data.findIndex(item => item.room_number === 'H25'), data.findIndex(item => item.room_number === 'H31') + 1));
            setBuildingH3238(data.slice(data.findIndex(item => item.room_number === 'H32'), data.findIndex(item => item.room_number === 'H38') + 1).reverse());
            setBuildingH6872(data.slice(data.findIndex(item => item.room_number === 'H68'), data.findIndex(item => item.room_number === 'H72') + 1));
            setBuildingH6367(data.slice(data.findIndex(item => item.room_number === 'H63'), data.findIndex(item => item.room_number === 'H67') + 1).reverse());
            setBuildingH4955(data.slice(data.findIndex(item => item.room_number === 'H49'), data.findIndex(item => item.room_number === 'H55') + 1));
            setBuildingH5662(data.slice(data.findIndex(item => item.room_number === 'H56'), data.findIndex(item => item.room_number === 'H62') + 1).reverse());
        } catch (err) {
            console.error(err.message);
        } 
    };

    useEffect(() => {
        getPhoneNumber();
    }, []);

    return (
        <div>
            {/* Header */}
            <div className="w-full h-[8dvh] bg-primary2 flex  items-center">
                <div className="md:w-[8%] pl-3 md:pl-10 items-center flex text-customWhite">
                    <NavLink to='/'>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 15.75 3 12m0 0 3.75-3.75M3 12h18" />
                        </svg>
                    </NavLink>
                </div>
                <div className="w-[84%] flex justify-center">
                    <h2 className="text-2xl font-semibold text-customWhite">ផែនទីអគារ</h2>
                </div>
            </div>
            {/* Body */}
            <div className="flex space-x-10 p-5">
                <div className='flex flex-col space-y-5'>
                    {/* Building N */}
                    <div className="flex flex-col">
                        <div className='grid grid-cols-2'>
                            <DisplayRoomInfo phoneNumberData={phoneNumberData} roomNumber={"N01"} />
                            <DisplayRoomInfo phoneNumberData={phoneNumberData} roomNumber={"N02"} />
                        </div>
                        <div className='grid grid-rows-5 grid-flow-col'>
                            {buildingN.length > 0 ? (
                                buildingN.map((data, index) => (
                                    <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                            {data.room_number}
                                        </div>
                                        {data.tenant_phone_number ? (
                                            <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                            {data.tenant_phone_number}
                                            </a>) : (
                                            <div className="map-box-phone" >No data</div>
                                        )}
                                    </div>
                                ))) : (
                                    <p>Loading ...</p>
                                )
                            }
                        </div>
                    </div>
                    {/* Building D */}
                    <div className='flex flex-col space-y-5'>
                        <div className='grid grid-rows-8 grid-flow-col'>
                            {buildingD1.length > 0 ? (
                                buildingD1.map((data, index) => (
                                    <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                            {data.room_number}
                                        </div>
                                        {data.tenant_phone_number ? (
                                            <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                            {data.tenant_phone_number}
                                            </a>) : (
                                            <div className="map-box-phone" >No data</div>
                                        )}
                                    </div>
                                ))) : (
                                    <p>Loading ...</p>
                                )
                            }
                            {buildingD2.length > 0 ? (
                                buildingD2.map((data, index) => (
                                    <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                            {data.room_number}
                                        </div>
                                        {data.tenant_phone_number ? (
                                            <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                            {data.tenant_phone_number}
                                            </a>) : (
                                            <div className="map-box-phone" >No data</div>
                                        )}
                                    </div>
                                ))) : (
                                    <p>Loading ...</p>
                                )
                            }
                        </div>
                        <div className='grid grid-cols-2'>
                            <DisplayRoomInfo phoneNumberData={phoneNumberData} roomNumber={"D10"} />
                            <DisplayRoomInfo phoneNumberData={phoneNumberData} roomNumber={"D09"} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-col space-y-5'>
                    <div className='flex space-x-10'>
                        {/* Building A */}
                        <div className='flex flex-col space-y-5'>
                            <div className='grid grid-rows-8 grid-flow-col'>
                                {buildingA1.length > 0 ? (
                                    buildingA1.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingA2.length > 0 ? (
                                    buildingA2.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                        </div>
                        {/* Building B */}
                        <div className='flex flex-col'>
                            <div className='grid grid-cols-2'>
                                <DisplayRoomInfo phoneNumberData={phoneNumberData} roomNumber={"B16"} />
                                <DisplayRoomInfo phoneNumberData={phoneNumberData} roomNumber={"B15"} />
                            </div>
                            <div className='grid grid-rows-7 grid-flow-col'>
                                {buildingB1.length > 0 ? (
                                    buildingB1.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingB2.length > 0 ? (
                                    buildingB2.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    {/* Building C */}
                    <div className='grid grid-cols-6'>
                        {buildingC.length > 0 ? (
                            buildingC.map((data, index) => (
                                <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                        {data.room_number}
                                    </div>
                                    {data.tenant_phone_number ? (
                                        <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                        {data.tenant_phone_number}
                                        </a>) : (
                                        <div className="map-box-phone" >No data</div>
                                    )}
                                </div>
                            ))) : (
                                <p>Loading ...</p>
                            )
                        }
                    </div>
                    <div className='flex space-x-10'>
                        {/* Building K */}
                        <div className='grid grid-rows-6 grid-flow-col'>
                            {buildingK.length > 0 ? (
                                buildingK.map((data, index) => (
                                    <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                ))) : (
                                    <p>Loading ...</p>
                                )
                            }
                        </div>
                        {/* Building R */}
                        <div className='grid grid-rows-7 grid-flow-col'>
                            {buildingK.length > 0 ? (
                                buildingR.map((data, index) => (
                                    <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                ))) : (
                                    <p>Loading ...</p>
                                )
                            }
                        </div>
                    </div>
                </div>
                <div className='flex flex-col'>
                    <div className='flex space-x-10'>
                        {/* Building H0 */}
                        <div className='flex flex-col bg-yellow-100 p-4'>
                            <div className='grid grid-rows-5 grid-flow-col'>
                                {buildingH2024.length > 0 ? (
                                    buildingH2024.map((data, index) => (
                                        <div key={index} className="flex flex-col ">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingH1519.length > 0 ? (
                                    buildingH1519.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                            <div className='text-center my-3 text-2xl'>ជាន់ដី</div>
                            <div className='grid grid-rows-7 grid-flow-col'>
                                {buildingH0107.length > 0 ? (
                                    buildingH0107.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingH0814.length > 0 ? (
                                    buildingH0814.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                        </div>
                        {/* Building H1 */}
                        <div className='flex flex-col bg-green-100 p-4'>
                            <div className='grid grid-rows-5 grid-flow-col'>
                                {buildingH4448.length > 0 ? (
                                    buildingH4448.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                        <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingH3943.length > 0 ? (
                                    buildingH3943.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                            <div className='text-center my-3 text-2xl'>ជាន់ទី 1</div>
                            <div className='grid grid-rows-7 grid-flow-col'>
                                {buildingH2531.length > 0 ? (
                                    buildingH2531.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingH3238.length > 0 ? (
                                    buildingH3238.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                        </div>
                        {/* Building H2 */}
                        <div className='flex flex-col bg-red-100 p-4'>
                            <div className='grid grid-rows-5 grid-flow-col'>
                                {buildingH6872.length > 0 ? (
                                    buildingH6872.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingH6367.length > 0 ? (
                                    buildingH6367.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                            <div className='text-center my-3 text-2xl'>ជាន់ទី 2</div>
                            <div className='grid grid-rows-7 grid-flow-col'>
                                {buildingH4955.length > 0 ? (
                                    buildingH4955.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                                {buildingH5662.length > 0 ? (
                                    buildingH5662.map((data, index) => (
                                        <div key={index} className="flex flex-col">
                                            <div className={`map-box-room ${!data.is_occupied ? "!bg-red-500" : "!bg-[#00A1FF]"}`}>
                                                {data.room_number}
                                            </div>
                                            {data.tenant_phone_number ? (
                                                <a className="map-box-phone" href={`tel:${data.tenant_phone_number}`}>
                                                {data.tenant_phone_number}
                                                </a>) : (
                                                <div className="map-box-phone" >No data</div>
                                            )}
                                        </div>
                                    ))) : (
                                        <p>Loading ...</p>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <div className='flex px-10 py-5 space-x-5'>
                        <div className='flex flex-col'>
                            <p className='text-xl font-medium'>A = 16</p>
                            <p className='text-xl font-medium'>B = 16</p>
                            <p className='text-xl font-medium'>C = 06</p>
                            <p className='text-xl font-medium'>D = 18</p>
                        </div>
                        <div className='flex flex-col'>
                            <p className='text-xl font-medium'>K = 12</p>
                            <p className='text-xl font-medium'>N = 12</p>
                            <p className='text-xl font-medium'>R = 14</p>
                            <p className='text-xl font-medium'>H = 72</p>
                        </div>
                        <div>
                            <p className='text-xl font-medium'>Total = 166</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}